// AUTO-GENERATED by generate-zod-schemas.ts — DO NOT EDIT
// Copyright 2026 Epic Digital Interactive Media LLC
// SPDX-License-Identifier: Apache-2.0

import { z } from 'zod'

export const processesSchema = z.object({
  id: z.string().max(100),
  orgId: z.string().max(100),
  workspaceId: z.string().max(100).optional(),
  userId: z.string().max(100).optional(),
  createdAt: z.string().max(200).datetime(),
  updatedAt: z.string().max(200).datetime(),
  metadata: z.record(z.string(), z.unknown()).optional(),
  extended: z.record(z.string(), z.unknown()).optional(),
  name: z.string().max(500),
  title: z.string().max(500),
  description: z.string().max(100000).optional(),
  version: z.string().max(200).optional(),
  status: z.string().max(50),
  category: z.string().max(200).optional(),
  startStepId: z.string().max(100).optional(),
  documentId: z.string().max(100).optional(),
  flowId: z.string().max(100).optional(),
  trigger: z.record(z.string(), z.unknown()).optional(),
  inputSchema: z.record(z.string(), z.unknown()).optional(),
  outputSchema: z.record(z.string(), z.unknown()).optional(),
  executionConfig: z.record(z.string(), z.unknown()).optional(),
  maxSubprocessDepth: z.number().int().optional(),
  executorAgentId: z.string().max(100).optional(),
  statistics: z.record(z.string(), z.unknown()).optional(),
  requiredCapabilities: z.array(z.string()).optional(),
  archived: z.boolean(),
  tenantId: z.string().max(100).optional(),
})

export type ProcessesInput = z.infer<typeof processesSchema>
